export default function () {
    const itemCounters = document.querySelectorAll('.product-counter');

    itemCounters.forEach((counter) => {
        const inputField = counter.querySelector('input');

        initUserControls(counter, inputField);
    });

    localStorage.setItem('productAmountBeforeRedirect', 1);
}

function initUserControls(counter, inputField) {
    counter.querySelector('.plus').addEventListener('click', function () {
        inputField.value = Number(inputField.value) + 1;
    }, false);
    counter.querySelector('.plus').addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            this.click();
        }
    }, false);
    counter.querySelector('.minus').addEventListener('click', function () {
        if (Number(inputField.value) > 1) {
            inputField.value = Number(inputField.value) - 1;
        }
    }, false);
    counter.querySelector('.minus').addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            this.click();
        }
    }, false);
}